export default {
  'pages.request.loginExpired': 'Срок действия сеанса истёк. Войдите снова.',
  'pages.request.accessDenied':
    'У вас нет разрешения на выполнение этого действия',
  'pages.request.responseStatus': 'Ошибка запроса (HTTP {status})',
  'pages.request.noResponse': 'Сервер не ответил. Повторите попытку позже.',
  'pages.request.error':
    'Не удалось выполнить запрос. Повторите попытку позже.',
  'pages.login.success': 'Вход выполнен успешно!',
  'pages.login.permissionsLoadFailed':
    'Не удалось загрузить права. Открыта личная адресная книга; обновите страницу, чтобы повторить попытку.',
  'pages.login.permissionsRetry': 'Повторить',
  'pages.login.failure': 'Ошибка входа, попробуйте снова!',
  'pages.login.username.placeholder': 'Имя пользователя',
  'pages.login.username.required': 'Пожалуйста, введите имя пользователя!',
  'pages.login.password.placeholder': 'Пароль',
  'pages.login.password.required': 'Пожалуйста, введите пароль!',
  'pages.login.rememberMe': 'Запомнить меня',
  'pages.login.forgotPassword': 'Забыли пароль?',
  'pages.login.forgotPasswordInfo':
    'Обратитесь к администратору для сброса пароля',
  'pages.login.submit': 'Войти',
  'pages.login.back': 'Назад',
  'pages.login.emailCheck.title': 'Подтверждение email',
  'pages.login.emailCheck.description': '6-значный код отправлен на {email}',
  'pages.login.emailCheck.sent': 'Код подтверждения отправлен на вашу почту',
  'pages.login.tfaCheck.title': 'Двухфакторная аутентификация',
  'pages.login.tfaCheck.description':
    'Введите 6-значный код из приложения-аутентификатора',
  'pages.login.verifyCode.submit': 'Подтвердить',
  'pages.login.verifyCode.invalid': 'Неверный код подтверждения',
  'pages.login.oidc.divider': 'Или продолжить через',
  'pages.login.oidc.continueWith': 'Продолжить через {provider}',
  'pages.login.oidc.authFailed': 'Ошибка входа через OIDC',
  'pages.login.passkey.login': 'Войти с Passkey',
  'pages.login.passkey.verify': 'Подтвердить с Passkey',
  'pages.login.passkey.cancelled': 'Подтверждение Passkey отменено',
  'pages.login.passkey.failed': 'Ошибка подтверждения Passkey',
  'pages.login.passkeyCheck.title': 'Подтверждение Passkey',
  'pages.login.passkeyCheck.description':
    'Используйте Passkey для завершения входа',
  'pages.devices.list': 'Список устройств',
  'pages.devices.os': 'ОС',
  'pages.devices.status': 'Статус',
  'pages.devices.user': 'Пользователь',
  'pages.devices.deviceGroup': 'Группа',
  'pages.devices.note': 'Примечание',
  'pages.devices.online': 'В сети',
  'pages.devices.offline': 'Не в сети',
  'pages.devices.days': 'дней',
  'pages.devices.hours': 'часов',
  'pages.devices.minutes': 'минут',
  'pages.devices.justNow': 'только что',
  'pages.devices.enable': 'Включить',
  'pages.devices.disable': 'Отключить',
  'pages.devices.enableSuccess': 'Устройство включено',
  'pages.devices.enableFailed': 'Не удалось включить устройство',
  'pages.devices.disableSuccess': 'Устройство отключено',
  'pages.devices.disableFailed': 'Не удалось отключить устройство',
  'pages.devices.deleteSuccess': 'Устройство удалено',
  'pages.devices.deleteFailed': 'Не удалось удалить устройство',
  'pages.devices.deleteConfirm':
    'Вы уверены, что хотите удалить это устройство?',
  'pages.devices.deviceInfo': 'username@device_name',
  'pages.devices.strategyInfo': 'Информация о стратегии',
  'pages.devices.device': 'Устройство',
  'pages.devices.strategy': 'Стратегия',
  'pages.devices.info': 'Информация',
  'pages.devices.statusNormal': 'Нормально',
  'pages.devices.statusDisabled': 'Отключено',
  'pages.devices.onlineStatus': 'Статус соединения',
  'pages.devices.deviceGroupSearchTip': 'Фильтр по названию группы устройств',
  'pages.devices.remove': 'Удалить',
  'pages.devices.removeFromGroupSuccess': 'Устройство удалено из группы',
  'pages.devices.removeFromGroupFailed':
    'Не удалось удалить устройство из группы',
  'pages.devices.removeFromGroupConfirm':
    'Вы уверены, что хотите удалить это устройство из группы?',
  'pages.devices.batchRemove': 'Массовое удаление',
  'pages.devices.batchRemoveFromGroupSuccess':
    'Успешно удалено {count} устройство(а) из группы',
  'pages.devices.batchRemoveFromGroupFailed':
    'Не удалось удалить устройства из группы',
  'pages.devices.batchRemoveFromGroupConfirm':
    'Вы уверены, что хотите удалить выбранные устройства из группы?',
  'pages.devices.batchEnable': 'Массовое включение',
  'pages.devices.batchDisable': 'Массовое отключение',
  'pages.devices.batchEnableConfirm':
    'Вы уверены, что хотите включить выбранные устройства?',
  'pages.devices.batchDisableConfirm':
    'Вы уверены, что хотите отключить выбранные устройства?',
  'pages.devices.batchEnableSuccess': 'Успешно включено {count} устройство(а)',
  'pages.devices.batchEnableFailed': 'Не удалось включить устройства',
  'pages.devices.batchEnablePartialFailed':
    'Успешно включено {success} устройство(а), {failed} не удалось',
  'pages.devices.batchDisableSuccess':
    'Успешно отключено {count} устройство(а)',
  'pages.devices.batchDisableFailed': 'Не удалось отключить устройства',
  'pages.devices.batchDisablePartialFailed':
    'Успешно отключено {success} устройство(а), {failed} не удалось',
  'pages.devices.edit': 'Редактировать устройство',
  'pages.devices.updateSuccess': 'Устройство обновлено',
  'pages.devices.updateFailed': 'Не удалось обновить устройство',
  'pages.devices.selectUser': 'Выберите пользователя',
  'pages.devices.selectDeviceGroup': 'Выберите группу устройств',
  'pages.devices.selectStrategy': 'Выберите стратегию',
  'pages.devices.connect': 'Подключить',
  'pages.devices.connectRemoteDesktop': 'Удалённый рабочий стол',
  'pages.devices.connectFileTransfer': 'Передача файлов',
  'pages.devices.connectViewCamera': 'Просмотр камеры',
  'pages.devices.connectPortForward': 'Перенаправление портов',
  'pages.devices.connectRdp': 'RDP',
  'pages.devices.connectTerminal': 'Терминал',
  'pages.devices.connectTerminalAdmin': 'Терминал (Админ)',
  'pages.devices.searchIdPlaceholder': 'Поиск по ID устройства',
  'pages.devices.searchUserPlaceholder': 'Поиск по имени пользователя',
  'pages.devices.searchOsPlaceholder': 'Поиск по ОС',
  'pages.devices.searchDeviceGroupPlaceholder':
    'Поиск по названию группы устройств',
  'pages.addressBook.name': 'Название',
  'pages.addressBook.note': 'Примечание',
  'pages.addressBook.shared': 'Общие адресные книги',
  'pages.addressBook.create': 'Создать адресную книгу',
  'pages.addressBook.edit': 'Редактировать адресную книгу',
  'pages.addressBook.personal': 'Личная адресная книга',
  'pages.addressBook.currentAddressBook': 'Адресная книга',
  'pages.addressBook.myAddressBook': 'Моя адресная книга',
  'pages.addressBook.loadFailed': 'Не удалось загрузить адресные книги',
  'pages.addressBook.addPeer': 'Добавить по ID',
  'pages.addressBook.addTag': 'Добавить тег',
  'pages.addressBook.tagName': 'Название тега',
  'pages.addressBook.tagAdded': 'Тег добавлен',
  'pages.addressBook.tagAddFailed': 'Не удалось добавить тег',
  'pages.addressBook.tagDeleted': 'Тег удален',
  'pages.addressBook.tagDeleteFailed': 'Не удалось удалить тег',
  'pages.addressBook.deleteTagConfirm':
    'Вы уверены, что хотите удалить этот тег?',
  'pages.addressBook.tagModeUnion': 'Любой',
  'pages.addressBook.tagModeIntersection': 'Все',
  'pages.addressBook.importDevices': 'Импорт из устройств',
  'pages.addressBook.importSuccess':
    'Успешно импортировано {count} устройство(а)',
  'pages.addressBook.importPartialFailed':
    'Не удалось импортировать {count} устройство(а)',
  'pages.addressBook.createSuccess': 'Адресная книга создана',
  'pages.addressBook.createFailed': 'Не удалось создать адресную книгу',
  'pages.addressBook.updateSuccess': 'Адресная книга обновлена',
  'pages.addressBook.updateFailed': 'Не удалось обновить адресную книгу',
  'pages.addressBook.deleteSuccess': 'Адресная книга(и) удалена(ы)',
  'pages.addressBook.deleteFailed': 'Не удалось удалить адресную книгу(и)',
  'pages.addressBook.deleteConfirm':
    'Вы уверены, что хотите удалить эту адресную книгу?',
  'pages.addressBook.batchDeleteConfirm':
    'Вы уверены, что хотите удалить выбранные адресные книги?',
  'pages.addressBook.device': 'Устройство',
  'pages.addressBook.alias': 'Псевдоним',
  'pages.addressBook.tags': 'Теги',
  'pages.addressBook.peerAdded': 'Участник добавлен',
  'pages.addressBook.peerAddFailed': 'Не удалось добавить участника',
  'pages.addressBook.peerDeleted': 'Участник удален',
  'pages.addressBook.peerDeleteFailed': 'Не удалось удалить участника',
  'pages.addressBook.deletePeerConfirm':
    'Вы уверены, что хотите удалить этого участника?',
  'pages.addressBook.import': 'Импорт из устройств',
  'pages.deviceGroups.list': 'Группы устройств',
  'pages.deviceGroups.name': 'Название',
  'pages.deviceGroups.note': 'Примечание',
  'pages.deviceGroups.create': 'Создать группу устройств',
  'pages.deviceGroups.edit': 'Редактировать группу устройств',
  'pages.deviceGroups.createSuccess': 'Группа устройств создана',
  'pages.deviceGroups.createFailed': 'Не удалось создать группу устройств',
  'pages.deviceGroups.updateSuccess': 'Группа устройств обновлена',
  'pages.deviceGroups.updateFailed': 'Не удалось обновить группу устройств',
  'pages.deviceGroups.deleteSuccess': 'Группа устройств удалена',
  'pages.deviceGroups.deleteFailed': 'Не удалось удалить группу устройств',
  'pages.deviceGroups.deleteConfirm':
    'Вы уверены, что хотите удалить эту группу устройств?',
  'pages.deviceGroups.import': 'Импорт',
  'pages.deviceGroups.importDevices': 'Импорт устройств',
  'pages.deviceGroups.importSuccess':
    'Успешно импортировано {count} устройство(а)',
  'pages.deviceGroups.importFailed': 'Не удалось импортировать устройства',
  'pages.deviceGroups.searchNamePlaceholder': 'Поиск по названию',
  'pages.users.list': 'Список пользователей',
  'pages.users.name': 'Имя',
  'pages.users.displayName': 'Отображаемое имя',
  'pages.users.email': 'Email',
  'pages.users.note': 'Примечание',
  'pages.users.status': 'Статус',
  'pages.users.create': 'Создать пользователя',
  'pages.users.createSuccess': 'Пользователь создан',
  'pages.users.createFailed': 'Не удалось создать пользователя',
  'pages.users.deleteSuccess': 'Пользователь удален',
  'pages.users.deleteFailed': 'Не удалось удалить пользователя',
  'pages.users.deleteConfirm':
    'Вы уверены, что хотите удалить этого пользователя?',
  'pages.audits.conn': 'Журнал подключений',
  'pages.audits.file': 'Журнал передачи файлов',
  'pages.audits.alarm': 'Журнал оповещений',
  'pages.audits.console': 'Журнал консоли',
  'pages.audits.requestedAt': 'Запрошено в',
  'pages.audits.establishedAt': 'Установлено в',
  'pages.audits.closedAt': 'Закрыто в',
  'pages.audits.action': 'Действие',
  'pages.audits.time': 'Время',
  'pages.audits.alarmType': 'Тип оповещения',
  'pages.audits.user': 'Пользователь',
  'pages.audits.detail': 'Детали',
  'pages.audits.operator': 'Оператор',
  'pages.audits.targetType': 'Тип цели',
  'pages.audits.targetId': 'Идентификатор цели',
  'pages.audits.result': 'Результат',
  'pages.audits.reason': 'Причина',
  'pages.audits.unknownUser': 'Неизвестный пользователь',
  'pages.audits.result.allowed': 'Разрешено',
  'pages.audits.result.denied': 'Отклонено',
  'pages.audits.target': 'Цель',
  'pages.audits.beforeState': 'Состояние до',
  'pages.audits.afterState': 'Состояние после',
  'pages.audits.type': 'Тип',
  'pages.audits.connType.remoteDesktop': 'Удаленный рабочий стол',
  'pages.audits.connType.fileTransfer': 'Передача файлов',
  'pages.audits.connType.portTransfer': 'Переадресация портов',
  'pages.audits.connType.viewCamera': 'Просмотр камеры',
  'pages.audits.connType.terminal': 'Терминал',
  'pages.audits.connType.notLoggedIn': 'Не авторизован',
  'pages.audits.duration': 'Длительность',
  'pages.audits.note': 'Примечание',
  'pages.audits.disconnect': 'Отключить',
  'pages.audits.connectionId': 'Идентификатор подключения',
  'pages.audits.currentConnections': 'Текущие подключения',
  'pages.audits.disconnectSuccess': 'Запрос на отключение отправлен',
  'pages.audits.disconnectFailed': 'Не удалось отключить!',
  'pages.audits.disconnectConfirmTitle': 'Подтверждение операции',
  'pages.audits.disconnectConfirmTip':
    'Вы уверены, что хотите отключить это устройство?',
  'pages.audits.updateSuccess': 'Обновление выполнено успешно',
  'pages.audits.updateFailed': 'Не удалось обновить, попробуйте снова!',
  'pages.audits.exportCSV': 'Экспорт в CSV',
  'pages.audits.noDataToExport': 'Нет данных для экспорта',
  'pages.audits.exportSuccess': 'Экспорт выполнен успешно',
  'pages.audits.exportFailed': 'Не удалось выполнить экспорт',
  'pages.audits.exportConfirmTitle': 'Экспорт в CSV',
  'pages.audits.exportConfirmContent':
    'Экспортируется до 1000 записей. Продолжить?',
  'pages.audits.remote': 'Удаленный',
  'pages.audits.local': 'Локальный',
  'pages.audits.direction': 'Направление',
  'pages.audits.files': 'Файлы',
  'pages.audits.remoteTip': 'Удаленно управляемый компьютер или терминал',
  'pages.audits.remoteSearchTip':
    'Поиск по ID удаленного устройства (нечеткое совпадение)',
  'pages.audits.remotePlaceholder': 'Введите ID удаленного устройства',
  'pages.audits.pathTip': 'Путь на удаленном устройстве',
  'pages.audits.exportCsvTip': 'Экспорт до 1000 записей за один раз',
  'pages.audits.limitedTip': 'Отображается 10 самых больших файлов по размеру',
  'pages.audits.startTime': 'Время начала',
  'pages.audits.endTime': 'Время окончания',
  'pages.audits.alarmType.ipWhitelist': 'IP не в белом списке',
  'pages.audits.alarmType.exceedThirtyAttempts':
    'С одного IP более 30 неудачных попыток',
  'pages.audits.alarmType.sixAttemptsWithinOneMinute':
    'Более 6 попыток за 1 минуту',
  'pages.audits.alarmType.exceedIpv6PrefixAttempts':
    'Превышен лимит попыток с IPv6-префикса',
  'pages.audits.alarmType.terminalOsLoginBackoff':
    'Блокировка входа в ОС терминала из-за задержки',
  'pages.audits.alarmType.terminalOsLoginConcurrency':
    'Превышен лимит одновременных входов в ОС терминала',
  'pages.audits.alarmType.sessionScopeViolation':
    'Нарушение разрешений в области сеанса',
  'pages.audits.alarmType.idWhitelist': 'ID не в белом списке',
  'pages.audits.primaryAuth': 'Основная аутентификация',
  'pages.audits.primaryAuth.none': 'Нет',
  'pages.audits.primaryAuth.click': 'Клик',
  'pages.audits.primaryAuth.temporaryPassword': 'Временный пароль',
  'pages.audits.primaryAuth.permanentPassword': 'Постоянный пароль',
  'pages.audits.primaryAuth.switchSides': 'Смена сторон',
  'pages.audits.twoFactor': 'Двухфакторная аутентификация',
  'pages.audits.twoFactor.none': 'Нет',
  'pages.audits.twoFactor.totp': 'TOTP',
  'pages.audits.twoFactor.trustedDevice': 'Доверенное устройство',
  'pages.audits.searchOperatorPlaceholder': 'Поиск по оператору',
  'pages.audits.searchActionPlaceholder': 'Поиск по действию',
  'pages.audits.searchTargetTypePlaceholder': 'Поиск по типу цели',
  'pages.common.action': 'Действие',
  'pages.common.delete': 'Удалить',
  'pages.common.edit': 'Редактировать',
  'pages.common.batchDelete': 'Массовое удаление',
  'pages.404.subTitle': 'Извините, запрашиваемая страница не найдена',
  'pages.404.buttonText': 'Вернуться на главную',
  'pages.customClients.createdAt': 'Дата создания',
  'pages.userGroups.list': 'Список групп пользователей',
  'pages.userGroups.name': 'Название группы',
  'pages.userGroups.note': 'Примечание',
  'pages.userGroups.userCount': 'Количество пользователей',
  'pages.userGroups.create': 'Создать группу пользователей',
  'pages.userGroups.edit': 'Редактировать группу пользователей',
  'pages.userGroups.deleteConfirm':
    'Вы уверены, что хотите удалить эту группу пользователей?',
  'pages.userGroups.createSuccess': 'Группа пользователей создана',
  'pages.userGroups.createFailed': 'Не удалось создать группу пользователей',
  'pages.userGroups.updateSuccess': 'Группа пользователей обновлена',
  'pages.userGroups.updateFailed': 'Не удалось обновить группу пользователей',
  'pages.userGroups.deleteSuccess': 'Группа пользователей удалена',
  'pages.userGroups.deleteFailed': 'Не удалось удалить группу пользователей',
  'pages.userGroups.loadFailed': 'Не удалось загрузить группы пользователей',
  'pages.userGroups.default': 'По умолчанию',
  'pages.userGroups.destination': 'Целевая группа',
  'pages.userGroups.selectDestination': 'Выберите целевую группу',
  'pages.userGroups.move': 'Переместить',
  'pages.userGroups.batchMove': 'Массовое перемещение',
  'pages.userGroups.moveToGroup': 'Переместить в группу',
  'pages.userGroups.import': 'Импорт',
  'pages.userGroups.importUsers': 'Импорт пользователей',
  'pages.userGroups.importSuccess':
    'Успешно импортировано {count} пользователь(ей)',
  'pages.userGroups.importFailed': 'Не удалось импортировать пользователей',
  'pages.userGroups.membersUpdated': 'Обновлено {count} пользователь(ей)',
  'pages.userGroups.membersUpdateFailed':
    'Не удалось обновить участников группы',
  'pages.userGroups.members': 'Участники',
  'pages.userGroups.moveSelected': 'Переместить выбранных',
  'pages.userGroups.addSelected': 'Добавить выбранных пользователей',
  'pages.userGroups.membersTitle': 'Участники группы {name}',
  'pages.userGroups.currentMembers': 'Текущие участники',
  'pages.userGroups.addUsers': 'Добавить пользователей',
  'pages.users.userGroup': 'Группа пользователей',
  'pages.users.selectUserGroup': 'Выберите группу пользователей',
  'pages.addressBook.userGroup': 'Группа пользователей',
  'pages.addressBook.permission': 'Права доступа',
  'pages.addressBook.permissionRead': 'Только чтение',
  'pages.addressBook.permissionReadWrite': 'Чтение и запись',
  'pages.addressBook.permissionFull': 'Полный доступ',
  'pages.addressBook.shareAccess': 'Общий доступ',
  'pages.addressBook.accessTitle': '{name} - Управление доступом',
  'pages.addressBook.accessReadOnlyTitle': 'Настройки общего доступа: {name}',
  'pages.addressBook.viewShareSettings': 'Настройки общего доступа',
  'pages.addressBook.shareType': 'Тип доступа',
  'pages.addressBook.shareTarget': 'Целевая аудитория',
  'pages.addressBook.shareTypeEveryone': 'Все пользователи',
  'pages.addressBook.shareTypeUser': 'Пользователь',
  'pages.addressBook.shareTypeGroup': 'Группа пользователей',
  'pages.addressBook.selectUser': 'Выберите пользователя',
  'pages.addressBook.selectUserPlaceholder':
    'Поиск по имени пользователя или email',
  'pages.addressBook.everyoneHint':
    'Все пользователи будут иметь доступ к этой адресной книге',
  'pages.addressBook.allUsers': 'Все пользователи',
  'pages.addressBook.addAccess': 'Добавить правило доступа',
  'pages.addressBook.accessLoadFailed': 'Не удалось загрузить правила доступа',
  'pages.addressBook.accessAdded': 'Правило доступа добавлено',
  'pages.addressBook.accessAddFailed': 'Не удалось добавить правило доступа',
  'pages.addressBook.accessUpdated': 'Правило доступа обновлено',
  'pages.addressBook.accessUpdateFailed': 'Не удалось обновить правило доступа',
  'pages.addressBook.accessDeleted': 'Правило доступа удалено',
  'pages.addressBook.accessDeleteFailed': 'Не удалось удалить правило доступа',
  'pages.addressBook.accessDeleteConfirm': 'Удалить это правило доступа?',
  'pages.roles.list': 'Список ролей',
  'pages.roles.name': 'Название роли',
  'pages.roles.note': 'Примечание',
  'pages.roles.permissions': 'Права',
  'pages.roles.permissionsInfo': 'Количество действующих прав и возможностей',
  'pages.roles.superAdminInfo':
    'Доступ суперадминистратора защищён отдельно и не может быть предоставлен через роль.',
  'pages.roles.permissionsLoadFailed': 'Не удалось загрузить каталог прав',
  'pages.roles.detailLoadFailed': 'Не удалось загрузить сведения о роли',
  'pages.roles.permissionScopeInfo':
    'При назначении роли действия с устройствами можно разрешить глобально или только для выбранных групп устройств.',
  'pages.roles.personalAddressBook': 'Личная адресная книга',
  'pages.roles.basicFunction': 'Базовая функция',
  'pages.roles.permissionPresets': 'Предустановки прав',
  'pages.roles.preset.custom': 'Пользовательский',
  'pages.roles.preset.readOnly': 'Глобальный просмотр',
  'pages.roles.preset.deviceOperator': 'Оператор устройств',
  'pages.roles.preset.userAdministrator': 'Администратор пользователей',
  'pages.roles.preset.sharedAddressBookAdministrator':
    'Администратор общих адресных книг',
  'pages.roles.preset.strategyMaintainer': 'Редактор стратегий',
  'pages.roles.preset.deviceStrategyAssigner':
    'Назначение стратегий устройствам',
  'pages.roles.preset.systemAdministrator': 'Системный администратор',
  'pages.roles.protectedAccount': 'Защищённые аккаунты',
  'pages.roles.protectedAccountInfo':
    'Управлять защищёнными аккаунтами может только суперадминистратор.',
  'pages.roles.ownerOnly': 'Только суперадминистратор',
  'pages.roles.systemIdentity.ordinary': 'Обычный пользователь',
  'pages.roles.systemIdentity.superAdmin': 'Суперадминистратор',
  'pages.roles.systemIdentity.builtIn': 'Встроенная система',
  'pages.roles.systemIdentity.ordinarySummary':
    'Только базовые функции личной адресной книги.',
  'pages.roles.systemIdentity.superAdminSummary':
    'Полные эффективные полномочия единственного владельца системы.',
  'pages.roles.systemIdentity.systemCapabilities':
    'Определение ролей, системные настройки, структура групп устройств и управление идентификацией',
  'pages.roles.disableProtectionConfirm': 'Отключить защиту этой роли?',
  'pages.roles.disableProtectionAffected':
    'Участники: {count}; ими смогут управлять делегированные администраторы.',
  'pages.roles.resource.servers': 'Серверы',
  'pages.roles.permission.servers.view': 'Просмотр серверов',
  'pages.roles.permission.servers.control': 'Управление службами серверов',
  'pages.roles.permission.servers.config': 'Настройка серверов',
  'pages.roles.permission.servers.disconnect':
    'Отключение сеансов ретрансляции',
  'pages.roles.permission.servers.ban': 'Управление блокировками серверов',
  'pages.roles.resource.users': 'Пользователи',
  'pages.roles.resource.user_groups': 'Группы пользователей',
  'pages.roles.resource.devices': 'Устройства',
  'pages.roles.resource.address_books': 'Адресные книги',
  'pages.roles.resource.strategies': 'Стратегии',
  'pages.roles.resource.audit': 'Аудит',
  'pages.roles.resource.roles': 'Роли',
  'pages.roles.resource.system': 'Системные возможности',
  'pages.roles.resource.other': 'Другое',
  'pages.roles.unknownResource': 'Неизвестный ресурс',
  'pages.roles.unknownPermission': 'Неизвестное право',
  'pages.roles.permission.users.view': 'Просмотр пользователей',
  'pages.roles.permission.users.create': 'Создание пользователей',
  'pages.roles.permission.users.edit': 'Редактирование пользователей',
  'pages.roles.permission.users.status': 'Изменение статуса пользователей',
  'pages.roles.permission.users.delete': 'Удаление пользователей',
  'pages.roles.permission.users.security':
    'Управление безопасностью пользователей',
  'pages.roles.permission.users.force_logout':
    'Принудительное завершение сеансов пользователей',
  'pages.roles.permission.user_groups.view': 'Просмотр групп пользователей',
  'pages.roles.permission.user_groups.create': 'Создание групп пользователей',
  'pages.roles.permission.user_groups.edit':
    'Редактирование групп пользователей',
  'pages.roles.permission.user_groups.delete': 'Удаление групп пользователей',
  'pages.roles.permission.user_groups.membership':
    'Управление составом групп пользователей',
  'pages.roles.permission.devices.view': 'Просмотр устройств',
  'pages.roles.permission.devices.edit':
    'Редактирование сведений об устройствах',
  'pages.roles.permission.devices.status': 'Изменение статуса устройств',
  'pages.roles.permission.devices.delete': 'Удаление устройств',
  'pages.roles.permission.devices.disconnect': 'Отключение устройств',
  'pages.roles.permission.address_books.view':
    'Просмотр настроек общих адресных книг',
  'pages.roles.permission.address_books.edit': 'Изменение общих адресных книг',
  'pages.roles.permission.address_books.share':
    'Создание и управление общими адресными книгами',
  'pages.roles.permission.strategies.view': 'Просмотр стратегий',
  'pages.roles.permission.strategies.create': 'Создание стратегий',
  'pages.roles.permission.strategies.edit': 'Редактирование стратегий',
  'pages.roles.permission.strategies.delete': 'Удаление стратегий',
  'pages.roles.permission.strategies.assign': 'Назначение стратегий',
  'pages.roles.permission.audit.view': 'Просмотр журналов аудита',
  'pages.roles.permission.roles.view': 'Просмотр ролей',
  'pages.roles.permission.roles.assign': 'Назначение ролей',
  'pages.roles.permission.roles.create': 'Создание ролей',
  'pages.roles.permission.roles.edit': 'Редактирование ролей',
  'pages.roles.permission.roles.delete': 'Удаление ролей',
  'pages.roles.create': 'Создать роль',
  'pages.roles.view': 'Просмотр роли',
  'pages.roles.edit': 'Редактировать роль',
  'pages.roles.deleteConfirm': 'Вы уверены, что хотите удалить эту роль?',
  'pages.roles.selectPermissions': 'Выберите права',
  'pages.roles.createSuccess': 'Роль успешно создана',
  'pages.roles.createFailed': 'Не удалось создать роль',
  'pages.roles.updateSuccess': 'Роль успешно обновлена',
  'pages.roles.updateFailed': 'Не удалось обновить роль',
  'pages.roles.deleteSuccess': 'Роль успешно удалена',
  'pages.roles.deleteFailed': 'Не удалось удалить роль',
  'pages.roles.searchNamePlaceholder': 'Поиск по названию роли',
  'pages.roles.searchNotePlaceholder': 'Поиск по примечанию',
  'pages.settings.save': 'Сохранить настройки',
  'pages.settings.general': 'Общие настройки',
  'pages.settings.fetchFailed': 'Не удалось загрузить настройки',
  'pages.settings.saveSuccess': 'Настройки успешно сохранены',
  'pages.settings.saveFailed': 'Не удалось сохранить настройки',
  'pages.settings.generalSection.watermark':
    'Водяной знак с именем пользователя',
  'pages.settings.generalSection.watermarkExtra':
    'Отображать имя текущего пользователя поверх каждой страницы для повышения ответственности.',
  'pages.settings.generalSection.language': 'Язык по умолчанию',
  'pages.settings.generalSection.languageExtra':
    'Язык интерфейса по умолчанию для новых посетителей. Авторизованные пользователи сохраняют свои предпочтения.',
  'pages.settings.generalSection.languagePlaceholder':
    'Выберите язык по умолчанию',
  'pages.settings.generalSection.site': 'Сайт',
  'pages.settings.generalSection.frontendUrl': 'URL фронтенда',
  'pages.settings.generalSection.frontendUrlPlaceholder':
    'https://console.example.com',
  'pages.settings.generalSection.backendUrl': 'URL бэкенда',
  'pages.settings.generalSection.backendUrlExtra':
    'Оставьте пустым для использования того же источника, что и фронтенд.',
  'pages.settings.generalSection.backendUrlPlaceholder':
    'https://api.example.com',
  'pages.settings.generalSection.urlInvalid':
    'Пожалуйста, введите корректный URL',
  'pages.settings.generalSection.webauthn': 'WebAuthn / Passkeys',
  'pages.settings.generalSection.webauthnEnabled': 'Включить WebAuthn',
  'pages.settings.generalSection.webauthnEnabledExtra':
    'Разрешить пользователям регистрироваться и входить с помощью ключей доступа (passkeys).',
  'pages.settings.generalSection.webauthnUnsupported':
    'Этот браузер не поддерживает WebAuthn. Вход с помощью passkey будет недоступен для пользователей на неподдерживаемых клиентах.',
  'pages.settings.generalSection.rpName': 'Название полагающейся стороны',
  'pages.settings.generalSection.rpNameExtra':
    'Понятное пользователю название, отображаемое в запросе на использование passkey.',
  'pages.settings.generalSection.rpNamePlaceholder': 'RustDesk Console',
  'pages.settings.generalSection.security': 'Безопасность и обслуживание',
  'pages.settings.generalSection.jwtExpiryDays':
    'Срок действия JWT-токена (дни)',
  'pages.settings.generalSection.jwtExpiryDaysExtra':
    'Количество дней до истечения срока действия токенов пользователей. Должно быть не менее 1.',
  'pages.settings.generalSection.jwtExpiryDaysRequired':
    'Введите положительное целое число',
  'pages.settings.generalSection.auditRetentionDays':
    'Хранение журналов аудита (дни)',
  'pages.settings.generalSection.auditRetentionDaysExtra':
    'Количество дней хранения журналов аудита перед автоматической очисткой. Установите 0 для отключения.',
  'pages.settings.generalSection.auditRetentionDaysRequired':
    'Введите неотрицательное целое число',
  'pages.strategies.list': 'Список стратегий',
  'pages.strategies.name': 'Название стратегии',
  'pages.strategies.note': 'Примечание',
  'pages.strategies.create': 'Создать стратегию',
  'pages.strategies.edit': 'Редактировать стратегию',
  'pages.strategies.view': 'Просмотреть стратегию',
  'pages.strategies.deleteConfirm':
    'Вы уверены, что хотите удалить эту стратегию?',
  'pages.strategies.createSuccess': 'Стратегия создана',
  'pages.strategies.createFailed': 'Не удалось создать стратегию',
  'pages.strategies.updateSuccess': 'Стратегия обновлена',
  'pages.strategies.updateFailed': 'Не удалось обновить стратегию',
  'pages.strategies.deleteSuccess': 'Стратегия удалена',
  'pages.strategies.deleteFailed': 'Не удалось удалить стратегию',
  'pages.strategies.enterName': 'Введите название стратегии',
  'pages.strategies.configOptions': 'Параметры конфигурации',
  'pages.strategies.defaultLabel': 'По умолчанию',
  'pages.strategies.defaultValue': 'По умолчанию: {value}',
  'pages.strategies.resetToDefault': 'Сбросить на значение по умолчанию',
  'pages.strategies.modifiedSummary': 'Изменено {count} параметр(ов)',
  'pages.strategies.resetAll': 'Сбросить все',
  'pages.strategies.assign': 'Назначить',
  'pages.strategies.assignManagement': 'Управление назначениями',
  'pages.strategies.loadAssignedFailed':
    'Не удалось загрузить назначенные цели',
  'pages.strategies.loadTargetsFailed': 'Не удалось загрузить цели',
  'pages.strategies.assignDevice': 'Устройство',
  'pages.strategies.assignUser': 'Пользователь',
  'pages.strategies.assignDeviceGroup': 'Группа устройств',
  'pages.strategies.assignedTargets': 'Назначенные объекты',
  'pages.strategies.noAssigned': 'Нет назначенных объектов',
  'pages.strategies.addAssignment': 'Добавить назначение',
  'pages.strategies.selectTarget': 'Выберите объект',
  'pages.strategies.assignSuccess': 'Стратегия успешно назначена',
  'pages.strategies.assignFailed': 'Не удалось назначить стратегию',
  'pages.strategies.assignPartialFailed':
    'Назначено {success} объект(ов), не удалось {failed}: {errors}',
  'pages.strategies.unassignSuccess': 'Назначение стратегии успешно отменено',
  'pages.strategies.unassignFailed': 'Не удалось отменить назначение стратегии',
  'pages.strategies.unassignConfirm': 'Отменить назначение для этого объекта?',
  'pages.strategies.fetchDetailFailed': 'Не удалось загрузить детали стратегии',
  'pages.strategies.updatedAt': 'Дата обновления',
  'pages.strategies.category.connection': 'Подключение и доступ',
  'pages.strategies.category.security': 'Безопасность и аутентификация',
  'pages.strategies.category.display': 'Отображение и интерфейс',
  'pages.strategies.category.av': 'Аудио/Видео и кодеки',
  'pages.strategies.category.file': 'Файлы и буфер обмена',
  'pages.strategies.category.advanced': 'Расширенные',
  'pages.strategies.category.floating': 'Плавающее окно',
  'pages.strategies.category.privacy': 'Конфиденциальность и запись',
  'pages.strategies.values.yes': 'Да',
  'pages.strategies.values.no': 'Нет',
  'pages.strategies.option.access-mode.label': 'Режим доступа',
  'pages.strategies.option.enable-keyboard.label': 'Включить клавиатуру и мышь',
  'pages.strategies.option.enable-clipboard.label': 'Включить буфер обмена',
  'pages.strategies.option.enable-file-transfer.label':
    'Включить передачу файлов',
  'pages.strategies.option.enable-camera.label': 'Включить камеру',
  'pages.strategies.option.enable-terminal.label': 'Включить терминал',
  'pages.strategies.option.enable-remote-printer.label':
    'Включить удалённый принтер',
  'pages.strategies.option.enable-tunnel.label': 'Включить туннель',
  'pages.strategies.option.enable-remote-restart.label':
    'Включить удалённый перезапуск',
  'pages.strategies.option.enable-block-input.label': 'Блокировать ввод',
  'pages.strategies.option.allow-auto-disconnect.label':
    'Разрешить автоматическое отключение',
  'pages.strategies.option.auto-disconnect-timeout.label':
    'Тайм-аут автоматического отключения',
  'pages.strategies.option.allow-only-conn-window-open.label':
    'Разрешать только открытое окно подключения',
  'pages.strategies.option.view-only.label': 'Только просмотр',
  'pages.strategies.option.terminal-persistent.label': 'Постоянный терминал',
  'pages.strategies.option.allow-ask-for-note.label':
    'Запрашивать примечание к подключению',
  'pages.strategies.option.allow-remote-config-modification.label':
    'Разрешить удалённое изменение конфигурации',
  'pages.strategies.option.whitelist.label': 'Список разрешённых IP',
  'pages.strategies.option.approve-mode.label': 'Режим подтверждения',
  'pages.strategies.option.verification-method.label': 'Способ проверки',
  'pages.strategies.option.temporary-password-length.label':
    'Длина временного пароля',
  'pages.strategies.option.lock-after-session-end.label':
    'Блокировать после завершения сеанса',
  'pages.strategies.option.allow-remote-cm-modification.label':
    'Разрешить удалённое изменение клиента',
  'pages.strategies.option.enable-trusted-devices.label':
    'Включить доверенные устройства',
  'pages.strategies.option.allow-numeric-one-time-password.label':
    'Разрешить числовой одноразовый пароль',
  'pages.strategies.option.allow-insecure-tls-fallback.label':
    'Разрешить небезопасный откат TLS',
  'pages.strategies.option.theme.label': 'Тема',
  'pages.strategies.option.lang.label': 'Язык',
  'pages.strategies.option.enable-confirm-closing-tabs.label':
    'Подтверждать закрытие вкладок',
  'pages.strategies.option.allow-remove-wallpaper.label':
    'Разрешить удаление обоев',
  'pages.strategies.option.enable-open-new-connections-in-tabs.label':
    'Открывать новые подключения во вкладках',
  'pages.strategies.option.peer-card-ui-type.label': 'Тип карточки устройства',
  'pages.strategies.option.peer-sorting.label': 'Сортировка устройств',
  'pages.strategies.option.show-monitors-toolbar.label':
    'Показывать панель мониторов',
  'pages.strategies.option.collapse-toolbar.label':
    'Сворачивать панель инструментов',
  'pages.strategies.option.show-remote-cursor.label':
    'Показывать удалённый курсор',
  'pages.strategies.option.follow-remote-cursor.label':
    'Следовать за удалённым курсором',
  'pages.strategies.option.follow-remote-window.label':
    'Следовать за удалённым окном',
  'pages.strategies.option.zoom-cursor.label': 'Увеличивать курсор',
  'pages.strategies.option.show-quality-monitor.label':
    'Показывать монитор качества',
  'pages.strategies.option.reverse-mouse-wheel.label':
    'Инвертировать колесо мыши',
  'pages.strategies.option.swap-left-right-mouse.label':
    'Поменять левую и правую кнопки мыши',
  'pages.strategies.option.displays-as-individual-windows.label':
    'Показывать мониторы отдельными окнами',
  'pages.strategies.option.use-all-my-displays-for-the-remote-session.label':
    'Использовать все мониторы в удалённом сеансе',
  'pages.strategies.option.view-style.label': 'Стиль просмотра',
  'pages.strategies.option.scroll-style.label': 'Стиль прокрутки',
  'pages.strategies.option.edge-scroll-edge-thickness.label':
    'Толщина прокрутки у края',
  'pages.strategies.option.trackpad-speed.label': 'Скорость трекпада',
  'pages.strategies.option.disable-group-panel.label': 'Отключить панель групп',
  'pages.strategies.option.keep-screen-on.label': 'Не выключать экран',
  'pages.strategies.option.disable-discovery-panel.label':
    'Отключить панель обнаружения',
  'pages.strategies.option.touch-mode.label': 'Сенсорный режим',
  'pages.strategies.option.show-virtual-mouse.label':
    'Показывать виртуальную мышь',
  'pages.strategies.option.show-virtual-joystick.label':
    'Показывать виртуальный джойстик',
  'pages.strategies.option.enable-audio.label': 'Включить звук',
  'pages.strategies.option.allow-always-software-render.label':
    'Всегда использовать программный рендеринг',
  'pages.strategies.option.enable-hwcodec.label': 'Включить аппаратный кодек',
  'pages.strategies.option.use-texture-render.label':
    'Использовать текстурный рендеринг',
  'pages.strategies.option.disable-audio.label': 'Отключить звук',
  'pages.strategies.option.i444.label': 'Цветовой формат I444',
  'pages.strategies.option.image-quality.label': 'Качество изображения',
  'pages.strategies.option.custom-image-quality.label':
    'Пользовательское качество изображения',
  'pages.strategies.option.custom-fps.label': 'Пользовательская частота кадров',
  'pages.strategies.option.enable-directx-capture.label':
    'Включить захват DirectX',
  'pages.strategies.option.enable-android-software-encoding-half-scale.label':
    'Включить программное кодирование Android в половинном масштабе',
  'pages.strategies.option.allow-d3d-render.label': 'Разрешить рендеринг D3D',
  'pages.strategies.option.enable-file-copy-paste.label':
    'Включить копирование и вставку файлов',
  'pages.strategies.option.disable-clipboard.label': 'Отключить буфер обмена',
  'pages.strategies.option.sync-init-clipboard.label':
    'Синхронизировать исходный буфер обмена',
  'pages.strategies.option.enable-lan-discovery.label':
    'Включить обнаружение в LAN',
  'pages.strategies.option.direct-server.label': 'Прямой сервер',
  'pages.strategies.option.allow-auto-update.label':
    'Разрешить автоматические обновления',
  'pages.strategies.option.enable-abr.label': 'Включить адаптивный битрейт',
  'pages.strategies.option.allow-linux-headless.label':
    'Разрешить безголовый режим Linux',
  'pages.strategies.option.sync-ab-with-recent-sessions.label':
    'Синхронизировать адресную книгу с последними сеансами',
  'pages.strategies.option.sync-ab-tags.label':
    'Синхронизировать теги адресной книги',
  'pages.strategies.option.filter-ab-by-intersection.label':
    'Фильтровать адресную книгу по пересечению',
  'pages.strategies.option.enable-udp-punch.label': 'Включить UDP-проброс',
  'pages.strategies.option.enable-ipv6-punch.label': 'Включить IPv6-проброс',
  'pages.strategies.option.pre-elevate-service.label':
    'Предварительно повысить права службы',
  'pages.strategies.option.keep-awake-during-incoming-sessions.label':
    'Не отключать сон во время входящих сеансов',
  'pages.strategies.option.keep-awake-during-outgoing-sessions.label':
    'Не отключать сон во время исходящих сеансов',
  'pages.strategies.option.disable-udp.label': 'Отключить UDP',
  'pages.strategies.option.allow-websocket.label': 'Разрешить WebSocket',
  'pages.strategies.option.disable-floating-window.label':
    'Отключить плавающее окно',
  'pages.strategies.option.floating-window-size.label':
    'Размер плавающего окна',
  'pages.strategies.option.floating-window-untouchable.label':
    'Плавающее окно без касаний',
  'pages.strategies.option.floating-window-transparency.label':
    'Прозрачность плавающего окна',
  'pages.strategies.option.enable-record-session.label':
    'Включить запись сеансов',
  'pages.strategies.option.allow-auto-record-incoming.label':
    'Разрешить автоматическую запись входящих сеансов',
  'pages.strategies.option.allow-auto-record-outgoing.label':
    'Разрешить автоматическую запись исходящих сеансов',
  'pages.strategies.option.privacy-mode.label': 'Режим конфиденциальности',
  'pages.strategies.option.auto-disconnect-timeout.description':
    'Тайм-аут в минутах',
  'pages.strategies.option.lang.description': 'Код языка',
  'pages.strategies.option.enable-ipv6-punch.description':
    'Собственный сервер: Нет, остальные: Да',
  'pages.strategies.option.use-texture-render.description':
    'Зависит от платформы',
  'pages.strategies.option.whitelist.description': 'Список IP через запятую',
  'pages.strategies.option.image-quality.value.best': 'Лучшее',
  'pages.strategies.option.image-quality.value.balanced': 'Сбалансированное',
  'pages.strategies.option.image-quality.value.low': 'Низкое',
  'pages.strategies.option.image-quality.value.custom': 'Пользовательское',
  'pages.strategies.option.access-mode.value.custom': 'Пользовательский',
  'pages.strategies.option.access-mode.value.full': 'Полный доступ',
  'pages.strategies.option.access-mode.value.view': 'Только просмотр',
  'pages.strategies.option.theme.value.dark': 'Тёмная',
  'pages.strategies.option.theme.value.light': 'Светлая',
  'pages.strategies.option.theme.value.system': 'Системная',
  'pages.strategies.option.peer-card-ui-type.value.0': 'Стиль карточки 0',
  'pages.strategies.option.peer-card-ui-type.value.1': 'Стиль карточки 1',
  'pages.strategies.option.peer-card-ui-type.value.2': 'Стиль карточки 2',
  'pages.strategies.option.peer-sorting.value.remote-id': 'Удалённый ID',
  'pages.strategies.option.peer-sorting.value.remote-host': 'Удалённый хост',
  'pages.strategies.option.peer-sorting.value.username': 'Имя пользователя',
  'pages.strategies.option.view-style.value.original': 'Исходный',
  'pages.strategies.option.view-style.value.adaptive': 'Адаптивный',
  'pages.strategies.option.scroll-style.value.scrollauto': 'Автоматический',
  'pages.strategies.option.scroll-style.value.scrollbar': 'Полоса прокрутки',
  'pages.strategies.option.scroll-style.value.scrolledge': 'Прокрутка у края',
  'pages.strategies.option.keep-screen-on.value.never': 'Никогда',
  'pages.strategies.option.keep-screen-on.value.during-controlled':
    'Во время управляемого сеанса',
  'pages.strategies.option.keep-screen-on.value.service-on':
    'При включённой службе',
  'pages.strategies.option.approve-mode.value.password': 'Пароль',
  'pages.strategies.option.approve-mode.value.click': 'Щелчок',
  'pages.strategies.option.approve-mode.value.password-click':
    'Пароль и щелчок',
  'pages.strategies.option.verification-method.value.use-temporary-password':
    'Временный пароль',
  'pages.strategies.option.verification-method.value.use-permanent-password':
    'Постоянный пароль',
  'pages.strategies.option.verification-method.value.use-both-passwords':
    'Оба пароля',
  'pages.strategies.option.temporary-password-length.value.6': '6 цифр',
  'pages.strategies.option.temporary-password-length.value.8': '8 цифр',
  'pages.strategies.option.temporary-password-length.value.10': '10 цифр',
  'pages.strategies.searchNamePlaceholder': 'Поиск по названию стратегии',
  'pages.users.inviteSuccess': 'Приглашение отправлено',
  'pages.users.inviteFailed': 'Не удалось отправить приглашение',
  'pages.users.active': 'Активен',
  'pages.users.disabled': 'Отключен',
  'pages.users.unverified': 'Не подтвержден',
  'pages.users.roles': 'Роли',
  'pages.users.rolesTitle': 'Роли пользователя {name}',
  'pages.users.rolesLoadFailed': 'Не удалось загрузить роли пользователя',
  'pages.users.rolesSaveFailed': 'Не удалось сохранить роли пользователя',
  'pages.users.rolesSaved': 'Роли пользователя сохранены',
  'pages.users.addRole': 'Добавить роль',
  'pages.users.superAdmin': 'Суперадминистратор',
  'pages.users.roleAssignmentTitle': 'Роль {number}',
  'pages.users.selectRole': 'Выберите роль',
  'pages.users.removeRole': 'Удалить роль',
  'pages.users.roleRequired': 'Выберите роль для каждого назначения',
  'pages.users.duplicateRole': 'Каждую роль можно назначить только один раз',
  'pages.users.scopeMode': 'Область действия роли',
  'pages.users.globalScope': 'Глобально',
  'pages.users.deviceGroupScope': 'Выбранные группы устройств',
  'pages.users.selectDeviceGroups':
    'Выберите одну или несколько групп устройств',
  'pages.users.unsupportedDeviceGroupScope':
    'Область по группам устройств доступна только для ролей с действиями над устройствами или назначением стратегий',
  'pages.users.deviceGroupScopeRequired':
    'Выберите хотя бы одну группу устройств',
  'pages.users.rolesScopeInfo':
    'Глобальные права перекрывают права для отдельных групп устройств.',
  'pages.users.protectedAccount': 'Защищённый аккаунт',
  'pages.users.protectedAccountInfo':
    'Управлять защищёнными аккаунтами может только суперадминистратор.',
  'pages.users.systemOwnerStatusBlocked':
    'Владельца системы нельзя активировать или отключить.',
  'pages.users.systemOwnerMutationBlocked':
    'Владельца системы нельзя отключить или удалить.',
  'pages.users.systemCapabilities': 'Системные возможности',
  'pages.users.systemCapability.roles.create': 'Создание определений ролей',
  'pages.users.systemCapability.roles.edit': 'Изменение определений ролей',
  'pages.users.systemCapability.roles.delete': 'Удаление определений ролей',
  'pages.users.systemCapability.settings.manage':
    'Управление системными настройками',
  'pages.users.systemCapability.device_groups.manage':
    'Управление структурой групп устройств',
  'pages.users.systemCapability.identity_sources.manage':
    'Управление источниками удостоверений',
  'pages.users.roleEligibility.assign_not_allowed':
    'Вы не можете назначить эту роль',
  'pages.users.roleEligibility.remove_not_allowed':
    'Вы не можете удалить эту роль',
  'pages.users.roleEligibility.protected_role':
    'Защищённые роли может назначать или удалять только суперадминистратор',
  'pages.users.roleEligibility.protected_target': 'Целевой аккаунт защищён',
  'pages.users.roleEligibility.super_admin_target':
    'Обычные роли нельзя назначать суперадминистратору',
  'pages.users.roleEligibility.self_target': 'Нельзя изменять собственные роли',
  'pages.users.roleEligibility.missing_caller_scope':
    'Недостаточный охват разрешений',
  'pages.users.roleEligibility.scope_exceeds_caller':
    'Охват роли превышает ваши разрешения',
  'pages.users.roleEligibility.missing_permission':
    'У вас нет разрешения, необходимого для этой роли',
  'pages.users.roleEligibility.role_grants_roles_assign':
    'Роли, предоставляющие назначение ролей, может изменять только суперадминистратор',
  'pages.users.effectiveScope': 'Фактическая область действия',
  'pages.users.strategy': 'Стратегия',
  'pages.users.invite': 'Пригласить пользователя',
  'pages.users.password': 'Пароль',
  'pages.users.isAdmin': 'Администратор',
  'pages.users.normalUser': 'Обычный',
  'pages.users.edit': 'Редактировать пользователя',
  'pages.users.updateSuccess': 'Пользователь обновлен',
  'pages.users.updateFailed': 'Не удалось обновить пользователя',
  'pages.users.security': 'Безопасность',
  'pages.users.securitySettings': 'Настройки безопасности',
  'pages.users.securityUpdateSuccess': 'Настройки безопасности обновлены',
  'pages.users.securityUpdateFailed':
    'Не удалось обновить настройки безопасности',
  'pages.users.tfaEnforce': 'Обязательная двухфакторная аутентификация',
  'pages.users.emailVerification': 'Требовать подтверждение email',
  'pages.users.resetPassword': 'Сбросить пароль',
  'pages.users.resetPasswordTooltip':
    'Оставьте пустым, чтобы сохранить текущий пароль',
  'pages.users.confirmPassword': 'Подтвердите пароль',
  'pages.users.passwordMismatch': 'Пароли не совпадают',
  'pages.users.passwordTooShort': 'Пароль должен содержать не менее 6 символов',
  'pages.users.forceLogout': 'Принудительный выход',
  'pages.users.forceLogoutSuccess': 'Принудительный выход выполнен успешно',
  'pages.users.forceLogoutFailed': 'Не удалось выполнить принудительный выход',
  'pages.users.batchEnable': 'Массовое включение',
  'pages.users.batchDisable': 'Массовое отключение',
  'pages.users.batchForceLogout': 'Массовый принудительный выход',
  'pages.users.batchEnableConfirm':
    'Вы уверены, что хотите включить выбранных пользователей?',
  'pages.users.batchDisableConfirm':
    'Вы уверены, что хотите отключить выбранных пользователей?',
  'pages.users.batchForceLogoutConfirm':
    'Вы уверены, что хотите выполнить принудительный выход для выбранных пользователей?',
  'pages.users.batchEnableSuccess': 'Успешно включено {count} пользователь(ей)',
  'pages.users.batchEnableFailed': 'Не удалось включить пользователей',
  'pages.users.batchEnablePartialFailed':
    'Успешно включено {success} пользователь(ей), {failed} не удалось',
  'pages.users.batchDisableSuccess':
    'Успешно отключено {count} пользователь(ей)',
  'pages.users.batchDisableFailed': 'Не удалось отключить пользователей',
  'pages.users.batchDisablePartialFailed':
    'Успешно отключено {success} пользователь(ей), {failed} не удалось',
  'pages.users.batchForceLogoutSuccess':
    'Массовый принудительный выход выполнен успешно',
  'pages.users.batchForceLogoutFailed':
    'Не удалось выполнить массовый принудительный выход',
  'pages.dashboard.totalUsers': 'Пользователи',
  'pages.dashboard.adminUsers': 'Админ',
  'pages.dashboard.normalUsers': 'Обычные',
  'pages.dashboard.totalDevices': 'Устройства',
  'pages.dashboard.onlineDevices': 'Онлайн',
  'pages.dashboard.offlineDevices': 'Офлайн',
  'pages.dashboard.todayConnections': 'Подключения',
  'pages.dashboard.successCount': 'Успех',
  'pages.dashboard.failureCount': 'Ошибка',
  'pages.dashboard.todayTransfers': 'Передачи',
  'pages.dashboard.uploadCount': 'Загрузка',
  'pages.dashboard.downloadCount': 'Скачивание',
  'pages.dashboard.systemStatus': 'Статус системы',
  'pages.dashboard.uptime': 'Время работы',
  'pages.dashboard.trendData': 'Тенденции',
  'pages.dashboard.alarmTrend': 'Оповещения',
  'pages.dashboard.resourceCounts': 'Ресурсы',
  'pages.dashboard.addressBooks': 'Адресные книги',
  'pages.dashboard.groups': 'Группы',
  'pages.dashboard.roles': 'Роли',
  'pages.dashboard.strategies': 'Стратегии',

  'pages.common.pleaseEnterName': 'Пожалуйста, введите название',
  'pages.common.pleaseEnterId': 'Пожалуйста, введите ID',
  'pages.common.pleaseEnterTagName': 'Пожалуйста, введите название тега',
  'pages.common.pleaseEnterUsername': 'Пожалуйста, введите имя пользователя',
  'pages.common.pleaseEnterEmail': 'Пожалуйста, введите email',
  'pages.common.pleaseEnterValidEmail': 'Пожалуйста, введите корректный email',
  'pages.common.pleaseEnterPassword': 'Пожалуйста, введите пароль',
  'pages.common.pleaseEnterRoleName': 'Пожалуйста, введите название роли',
  'pages.common.id': 'ID',
  'pages.dashboard.day': 'д',
  'pages.dashboard.hour': 'ч',
  'pages.dashboard.min': 'мин',
  'pages.dashboard.cpu': 'ЦП',
  'pages.dashboard.memory': 'Память',
  'pages.dashboard.disk': 'Диск',
  'pages.dashboard.connectionTrend': 'Подключения',
  'pages.dashboard.newUsersTrend': 'Новые пользователи',

  'pages.dashboard.7days': '7 дней',
  'pages.dashboard.30days': '30 дней',
  'pages.dashboard.90days': '90 дней',
  'pages.dashboard.noData': 'Нет данных',
  'pages.smtp.title': 'Настройки SMTP',
  'pages.smtp.description':
    'Настройте SMTP-сервер для отправки системных уведомлений по электронной почте',
  'pages.smtp.host': 'Адрес сервера',
  'pages.smtp.hostPlaceholder': 'Введите адрес SMTP-сервера',
  'pages.smtp.port': 'Порт',
  'pages.smtp.portPlaceholder': 'Введите номер порта',
  'pages.smtp.secure': 'Использовать SSL/TLS',
  'pages.smtp.secureHelp':
    'Включить защищенное соединение (обычно порт 465 использует SSL, порт 587 использует TLS)',
  'pages.smtp.user': 'Имя пользователя',
  'pages.smtp.userPlaceholder':
    'Введите имя пользователя для аутентификации SMTP',
  'pages.smtp.password': 'Пароль',
  'pages.smtp.passwordPlaceholder': 'Введите пароль для аутентификации SMTP',
  'pages.smtp.from': 'Email отправителя',
  'pages.smtp.fromPlaceholder': 'Введите адрес электронной почты отправителя',
  'pages.smtp.enabled': 'Включить конфигурацию',
  'pages.smtp.enabledHelp':
    'При включении эта конфигурация будет использоваться для отправки системных писем',
  'pages.smtp.testConnection': 'Проверить подключение',
  'pages.smtp.testSuccess': 'Проверка SMTP-подключения выполнена успешно',
  'pages.smtp.testFailed': 'Ошибка проверки SMTP-подключения',
  'pages.smtp.saveSuccess': 'Настройки SMTP успешно сохранены',
  'pages.smtp.saveFailed': 'Не удалось сохранить настройки SMTP',
  'pages.smtp.createdAt': 'Дата создания',
  'pages.smtp.updatedAt': 'Дата обновления',
  'pages.addressBook.color': 'Цвет',
  'pages.addressBook.deviceInfo': 'username@device_name',
  'pages.addressBook.manageTags': 'Управление тегами',
  'pages.addressBook.newTagName': 'Название нового тега',
  'pages.addressBook.peerUpdateFailed': 'Не удалось обновить участника',
  'pages.addressBook.peerUpdated': 'Участник обновлен',
  'pages.addressBook.renameTag': 'Переименовать тег',
  'pages.addressBook.selectTags': 'Выберите теги',
  'pages.addressBook.tagColorUpdateFailed': 'Не удалось обновить цвет тега',
  'pages.addressBook.tagRenameFailed': 'Не удалось переименовать тег',
  'pages.addressBook.tagRenamed': 'Тег переименован',
  'pages.addressBook.untagged': 'Без тегов',
  'pages.addressBook.searchIdPlaceholder': 'Поиск по ID',
  'pages.addressBook.searchNamePlaceholder': 'Поиск по названию',
  'pages.addressBook.searchNotePlaceholder': 'Поиск по примечанию',
  'pages.common.cancel': 'Нет',
  'pages.common.confirm': 'Да',
  'pages.common.enterDescription': 'Введите описание',
  'pages.common.rename': 'Переименовать',
  'pages.common.save': 'Сохранить',
  'pages.common.close': 'Закрыть',
  'pages.common.back': 'Назад',
  'pages.userGroups.enterName': 'Введите название группы',
  'pages.userGroups.searchNamePlaceholder': 'Поиск по названию',
  'pages.users.admin': 'Администратор',
  'pages.users.me': 'Я',
  'pages.users.searchNamePlaceholder': 'Поиск по имени пользователя',
  'pages.users.searchEmailPlaceholder': 'Поиск по email',
  'pages.users.searchStrategyPlaceholder': 'Поиск по стратегии',
  'pages.users.searchUserGroupPlaceholder': 'Поиск по группе пользователей',
  'pages.oidcProviders.list': 'Провайдеры OIDC',
  'pages.oidcProviders.sort': 'Сортировка',
  'pages.oidcProviders.name': 'Название провайдера',
  'pages.oidcProviders.type': 'Тип',
  'pages.oidcProviders.issuer': 'URL эмитента',
  'pages.oidcProviders.clientId': 'ID клиента',
  'pages.oidcProviders.clientSecret': 'Секрет клиента',
  'pages.oidcProviders.scope': 'Области доступа',
  'pages.oidcProviders.authorizationEndpoint': 'Эндпоинт авторизации',
  'pages.oidcProviders.tokenEndpoint': 'Эндпоинт токенов',
  'pages.oidcProviders.userinfoEndpoint': 'Эндпоинт информации о пользователе',
  'pages.oidcProviders.jwksUri': 'URI JWKS',
  'pages.oidcProviders.enabled': 'Включен',
  'pages.oidcProviders.endpointConfig': 'Конфигурация эндпоинтов',
  'pages.oidcProviders.create': 'Создать провайдера',
  'pages.oidcProviders.edit': 'Редактировать провайдера',
  'pages.oidcProviders.test': 'Проверить',
  'pages.oidcProviders.testResult': 'Результат проверки подключения',
  'pages.oidcProviders.discoveredEndpoints': 'Обнаруженные эндпоинты',
  'pages.oidcProviders.enterName': 'Введите название провайдера',
  'pages.oidcProviders.enterIssuer': 'Введите URL эмитента',
  'pages.oidcProviders.enterClientId': 'Введите ID клиента',
  'pages.oidcProviders.enterClientSecret': 'Введите секрет клиента',
  'pages.oidcProviders.enterEndpoint': 'Автообнаружение, если оставить пустым',
  'pages.oidcProviders.createSuccess': 'Провайдер OIDC создан',
  'pages.oidcProviders.createFailed': 'Не удалось создать провайдера OIDC',
  'pages.oidcProviders.updateSuccess': 'Провайдер OIDC обновлен',
  'pages.oidcProviders.updateFailed': 'Не удалось обновить провайдера OIDC',
  'pages.oidcProviders.deleteSuccess': 'Провайдер OIDC удален',
  'pages.oidcProviders.deleteFailed': 'Не удалось удалить провайдера OIDC',
  'pages.oidcProviders.deleteConfirm':
    'Вы уверены, что хотите удалить этого провайдера?',
  'pages.oidcProviders.enableSuccess': 'Провайдер OIDC включен',
  'pages.oidcProviders.enableFailed': 'Не удалось включить провайдера OIDC',
  'pages.oidcProviders.disableSuccess': 'Провайдер OIDC отключен',
  'pages.oidcProviders.disableFailed': 'Не удалось отключить провайдера OIDC',
  'pages.oidcProviders.enableConfirm':
    'Вы уверены, что хотите включить этого провайдера?',
  'pages.oidcProviders.disableConfirm':
    'Вы уверены, что хотите отключить этого провайдера?',
  'pages.oidcProviders.testFailed': 'Не удалось проверить подключение OIDC',
  'pages.oidcProviders.fetchDetailFailed':
    'Не удалось загрузить детали провайдера',
  'pages.oidcProviders.sortFailed': 'Не удалось обновить порядок провайдеров',
  'pages.oidcProviders.preset': 'Шаблон провайдера',
  'pages.oidcProviders.presetPlaceholder':
    'Выберите встроенного провайдера или пользовательский',
  'pages.oidcProviders.custom': 'Пользовательский',
  'pages.oidcProviders.icon': 'Иконка (SVG)',
  'pages.oidcProviders.uploadSvg': 'Загрузить SVG',
  'pages.oidcProviders.clearIcon': 'Очистить',
  'pages.oidcProviders.svgTooLarge': 'SVG-файл слишком большой (макс. 100КБ)',
  'pages.oidcProviders.invalidSvg': 'Недействительное содержимое SVG',
  'pages.user.center.tab.basic': 'Основная информация',
  'pages.user.center.tab.security': 'Безопасность',
  'pages.user.center.basicInfo.displayName': 'Отображаемое имя',
  'pages.user.center.basicInfo.displayNamePlaceholder':
    'Введите отображаемое имя',
  'pages.user.center.basicInfo.name': 'Имя пользователя',
  'pages.user.center.basicInfo.email': 'Email',
  'pages.user.center.basicInfo.note': 'Примечание',
  'pages.user.center.basicInfo.updateSuccess': 'Профиль успешно обновлен',
  'pages.user.center.basicInfo.updateFailed': 'Не удалось обновить профиль',
  'pages.user.center.avatar.hint':
    'Поддерживается JPG, PNG, WebP, макс. 2 МБ, будет изменен до 256x256',
  'pages.user.center.avatar.upload': 'Загрузить аватар',
  'pages.user.center.avatar.delete': 'Удалить аватар',
  'pages.user.center.avatar.deleteConfirm':
    'Вы уверены, что хотите удалить свой аватар?',
  'pages.user.center.avatar.uploadSuccess': 'Аватар успешно загружен',
  'pages.user.center.avatar.uploadFailed': 'Не удалось загрузить аватар',
  'pages.user.center.avatar.deleteSuccess': 'Аватар успешно удален',
  'pages.user.center.avatar.deleteFailed': 'Не удалось удалить аватар',
  'pages.user.center.avatar.fileTooLarge':
    'Размер файла не может превышать 2 МБ',
  'pages.user.center.avatar.invalidFormat':
    'Поддерживаются только форматы JPG, PNG, WebP',
  'pages.user.center.security.title': 'Настройки безопасности',
  'pages.user.center.security.2faStatus': 'Статус 2FA',
  'pages.user.center.security.enabled': 'Включена',
  'pages.user.center.security.disabled': 'Отключена',
  'pages.user.center.security.enable2FA': 'Включить 2FA',
  'pages.user.center.security.disable2FA': 'Отключить 2FA',
  'pages.user.center.security.setup2FA':
    'Настройка двухфакторной аутентификации',
  'pages.user.center.security.setupFailed': 'Не удалось настроить 2FA',
  'pages.user.center.security.scanQRCode':
    'Отсканируйте QR-код в приложении-аутентификаторе, затем введите код подтверждения ниже.',
  'pages.user.center.security.secretKey': 'Секретный ключ',
  'pages.user.center.security.verificationCode': 'Код подтверждения',
  'pages.user.center.security.enterCode':
    'Пожалуйста, введите код подтверждения',
  'pages.user.center.security.verifyAndEnable': 'Подтвердить и включить',
  'pages.user.center.security.enableSuccess': '2FA успешно включена',
  'pages.user.center.security.enableFailed': 'Не удалось включить 2FA',
  'pages.user.center.security.currentCode': 'Текущий код подтверждения',
  'pages.user.center.security.confirmDisable': 'Подтвердить отключение',
  'pages.user.center.security.disableSuccess': '2FA успешно отключена',
  'pages.user.center.security.disableFailed': 'Не удалось отключить 2FA',
  'pages.user.center.security.password': 'Пароль входа',
  'pages.user.center.security.passwordSet': 'Установлен',
  'pages.user.center.security.passwordNotSet': 'Не установлен',
  'pages.user.center.security.changePassword': 'Изменить пароль',
  'pages.user.center.security.currentPassword': 'Текущий пароль',
  'pages.user.center.security.enterCurrentPassword':
    'Пожалуйста, введите текущий пароль',
  'pages.user.center.security.newPassword': 'Новый пароль',
  'pages.user.center.security.enterNewPassword':
    'Пожалуйста, введите новый пароль (минимум 6 символов)',
  'pages.user.center.security.confirmNewPassword': 'Подтвердите новый пароль',
  'pages.user.center.security.confirmNewPasswordPlaceholder':
    'Пожалуйста, введите новый пароль еще раз',
  'pages.user.center.security.passwordMinLength':
    'Пароль должен содержать минимум 6 символов',
  'pages.user.center.security.passwordMismatch': 'Пароли не совпадают',
  'pages.user.center.security.changePasswordSuccess': 'Пароль успешно изменен',
  'pages.user.center.security.changePasswordFailed':
    'Не удалось изменить пароль',
  'pages.user.center.security.thirdPartyUser':
    'Пользователи, вошедшие через сторонние сервисы, не могут изменить пароль',
  'pages.user.center.security.noPasswordUser':
    'Для этой учетной записи не установлен пароль',
  'pages.user.center.security.passkey.title': 'Управление Passkey',
  'pages.user.center.security.passkey.register': 'Зарегистрировать Passkey',
  'pages.user.center.security.passkey.registerSuccess':
    'Passkey успешно зарегистрирован',
  'pages.user.center.security.passkey.registerFailed':
    'Не удалось зарегистрировать Passkey',
  'pages.user.center.security.passkey.deleteSuccess': 'Passkey успешно удален',
  'pages.user.center.security.passkey.deleteFailed':
    'Не удалось удалить Passkey',
  'pages.user.center.security.passkey.deleteConfirm':
    'Вы уверены, что хотите удалить этот Passkey?',
  'pages.user.center.security.passkey.name': 'Название',
  'pages.user.center.security.passkey.namePlaceholder':
    'например, MacBook Touch ID',
  'pages.user.center.security.passkey.namePasskey': 'Назовите ваш Passkey',
  'pages.user.center.security.passkey.deviceType': 'Тип устройства',
  'pages.user.center.security.passkey.multiDevice': 'Мультиустройство',
  'pages.user.center.security.passkey.singleDevice': 'Одно устройство',
  'pages.user.center.security.passkey.createdAt': 'Дата создания',
  'pages.user.center.security.passkey.noCredentials':
    'Passkey не зарегистрированы',
  'pages.user.center.security.passkey.tfaStatus': 'TFA через Passkey',
  'pages.user.center.security.passkey.tfaEnabled': 'TFA через Passkey включена',
  'pages.user.center.security.passkey.tfaDisabled':
    'TFA через Passkey отключена',
  'pages.user.center.security.passkey.tfaToggleFailed':
    'Не удалось изменить состояние TFA через Passkey',
  'pages.user.center.security.sessions.title': 'Сессии входа',
  'pages.user.center.security.sessions.device': 'Устройство',
  'pages.user.center.security.sessions.type': 'Тип',
  'pages.user.center.security.sessions.browser': 'Браузер',
  'pages.user.center.security.sessions.client': 'Клиент',
  'pages.user.center.security.sessions.os': 'ОС',
  'pages.user.center.security.sessions.createdAt': 'Дата создания',
  'pages.user.center.security.sessions.expiresAt': 'Истекает',
  'pages.user.center.security.sessions.current': 'Текущая',
  'pages.user.center.security.sessions.revoke': 'Отозвать',
  'pages.user.center.security.sessions.revokeConfirm':
    'Вы уверены, что хотите отозвать эту сессию?',
  'pages.user.center.security.sessions.revokeSuccess':
    'Сессия успешно отозвана',
  'pages.user.center.security.sessions.revokeFailed':
    'Не удалось отозвать сессию',
  'pages.user.center.security.sessions.cannotRevokeCurrent':
    'Нельзя отозвать текущую сессию',
  'pages.user.center.security.sessions.noSessions': 'Нет активных сессий',
  'pages.ldap.title': 'Настройки LDAP',
  'pages.ldap.description':
    'Настройте аутентификацию через LDAP/Active Directory. При включении пользователи будут автоматически проходить аутентификацию через LDAP.',
  'pages.ldap.urls': 'URL серверов',
  'pages.ldap.urlsRequired':
    'Пожалуйста, введите хотя бы один URL LDAP-сервера',
  'pages.ldap.urlPlaceholder': 'например, ldaps://ad.example.com:636',
  'pages.ldap.addUrl': 'Добавить URL сервера',
  'pages.ldap.bindDN': 'Bind DN',
  'pages.ldap.bindDNRequired':
    'Пожалуйста, введите Bind DN служебной учетной записи',
  'pages.ldap.bindDNPlaceholder':
    'например, CN=svc-ldap,OU=ServiceAccounts,DC=example,DC=com',
  'pages.ldap.bindCredentials': 'Пароль для Bind',
  'pages.ldap.bindCredentialsRequired':
    'Пожалуйста, введите пароль служебной учетной записи',
  'pages.ldap.bindCredentialsPlaceholder':
    'Введите пароль служебной учетной записи',
  'pages.ldap.searchBase': 'Базовый DN для поиска',
  'pages.ldap.searchBaseRequired': 'Пожалуйста, введите базовый DN для поиска',
  'pages.ldap.searchBasePlaceholder': 'например, DC=example,DC=com',
  'pages.ldap.searchFilter': 'Фильтр поиска',
  'pages.ldap.searchFilterRequired': 'Пожалуйста, введите фильтр поиска',
  'pages.ldap.searchFilterHelp':
    'Используйте {{username}} как плейсхолдер имени пользователя. AD: (sAMAccountName={{username}}), OpenLDAP: (uid={{username}})',
  'pages.ldap.searchFilterPlaceholder':
    'например, (sAMAccountName={{username}})',
  'pages.ldap.searchAttributes': 'Атрибуты поиска',
  'pages.ldap.searchAttributePlaceholder':
    'например, dn, sAMAccountName, mail, displayName',
  'pages.ldap.addAttribute': 'Добавить атрибут',
  'pages.ldap.groupSearchBase': 'Базовый DN для поиска групп',
  'pages.ldap.groupSearchBasePlaceholder':
    'например, OU=Groups,DC=example,DC=com',
  'pages.ldap.groupSearchFilter': 'Фильтр поиска групп',
  'pages.ldap.groupSearchFilterHelp':
    'Используйте {{dn}} как плейсхолдер DN пользователя. например, (member={{dn}})',
  'pages.ldap.groupSearchFilterPlaceholder': 'например, (member={{dn}})',
  'pages.ldap.adminGroups': 'Группы администраторов',
  'pages.ldap.adminGroupsHelp':
    'Пользователи из этих групп LDAP будут назначены администраторами (регистр не учитывается)',
  'pages.ldap.adminGroupPlaceholder':
    'например, CN=Admins,OU=Groups,DC=example,DC=com',
  'pages.ldap.addAdminGroup': 'Добавить группу администраторов',
  'pages.ldap.tlsOptions': 'Настройки TLS',
  'pages.ldap.tlsCa': 'Сертификат CA (PEM)',
  'pages.ldap.tlsCaPlaceholder': '-----BEGIN CERTIFICATE-----\n...',
  'pages.ldap.tlsCert': 'Клиентский сертификат (PEM)',
  'pages.ldap.tlsCertPlaceholder': '-----BEGIN CERTIFICATE-----\n...',
  'pages.ldap.tlsKey': 'Приватный ключ клиента (PEM)',
  'pages.ldap.tlsKeyPlaceholder': '-----BEGIN PRIVATE KEY-----\n...',
  'pages.ldap.tlsServername': 'Имя сервера SNI',
  'pages.ldap.tlsServernamePlaceholder': 'Server Name Indication для TLS',
  'pages.ldap.enabled': 'Включить аутентификацию LDAP',
  'pages.ldap.enabledHelp':
    'При включении пользователи будут проходить аутентификацию через LDAP-сервер. Существующие пользователи, привязанные к LDAP, всегда используют LDAP-аутентификацию независимо от этой настройки.',
  'pages.ldap.testConnection': 'Проверить подключение',
  'pages.ldap.testSuccess': 'Проверка LDAP-подключения выполнена успешно',
  'pages.ldap.testFailed': 'Ошибка проверки LDAP-подключения',
  'pages.ldap.saveSuccess': 'Настройки LDAP успешно сохранены',
  'pages.ldap.saveFailed': 'Не удалось сохранить настройки LDAP',
  'pages.ldap.createdAt': 'Дата создания',
  'pages.ldap.updatedAt': 'Дата обновления',
  'pages.nexus.repoRequired': 'Требуется взаимодействие с репозиторием',
  'pages.nexus.repoRequiredDesc':
    'Вам необходимо поставить Star, Fork или Watch на репозиторий databk/rustdesk-console на GitHub перед генерацией пользовательских клиентов. Обновление кеша может занять до 5 минут.',
  'pages.nexus.goToRepo': 'Перейти в репозиторий GitHub',
  'pages.nexus.buildList': 'История сборок',
  'pages.nexus.createBuild': 'Создать новый клиент',
  'pages.nexus.createBuildTitle': 'Создание пользовательского клиента',
  'pages.nexus.customConfig': 'Пользовательские настройки',
  'pages.nexus.serverConfig': 'Конфигурация сервера',
  'pages.nexus.password': 'Пароль',
  'pages.nexus.passwordPlaceholder': 'Введите пароль',
  'pages.nexus.salt': 'Соль',
  'pages.nexus.saltPlaceholder': 'Введите соль',
  'pages.nexus.connType': 'Тип подключения',
  'pages.nexus.disableInstallation': 'Отключить установку',
  'pages.nexus.disableSettings': 'Отключить настройки',
  'pages.nexus.disableAccount': 'Отключить учетную запись',
  'pages.nexus.disableAb': 'Отключить AB',
  'pages.nexus.disableTcpListen': 'Отключить TCP Listen',
  'pages.nexus.rendezvousServer': 'ID-сервер',
  'pages.nexus.relayServer': 'Relay-сервер',
  'pages.nexus.key': 'Ключ',
  'pages.nexus.apiServer': 'API-сервер',
  'pages.nexus.overrideSettings': 'Переопределить настройки',
  'pages.nexus.defaultSettings': 'Настройки по умолчанию',
  'pages.nexus.deleteBuildConfirm':
    'Вы уверены, что хотите удалить эту запись сборки?',
  'pages.nexus.deleteSuccess': 'Запись сборки удалена',
  'pages.nexus.deleteFailed': 'Не удалось удалить запись сборки',
  'pages.nexus.uuid': 'UUID',
  'pages.nexus.os': 'Операционная система',
  'pages.nexus.arch': 'Архитектура',
  'pages.nexus.appName': 'Название приложения',
  'pages.nexus.appNamePlaceholder': 'например, my-rustdesk',
  'pages.nexus.appNameHint': 'Разрешены только английские буквы',
  'pages.nexus.bindSuccess': 'Учетная запись GitHub успешно привязана',
  'pages.nexus.bindFailed': 'Не удалось привязать учетную запись GitHub',
  'pages.nexus.createLoginFailed': 'Не удалось создать сессию входа',
  'pages.nexus.unbindConfirm': 'Отвязать учетную запись GitHub',
  'pages.nexus.unbindConfirmContent':
    'Вы уверены, что хотите отвязать учетную запись GitHub? Для генерации пользовательских клиентов потребуется повторная привязка.',
  'pages.nexus.unbindSuccess': 'Учетная запись GitHub отвязана',
  'pages.nexus.unbindFailed': 'Не удалось отвязать учетную запись GitHub',
  'pages.nexus.tokenExpired': 'Токен GitHub истек',
  'pages.nexus.tokenExpiredDesc':
    'Ваш токен GitHub для {username} истек. Пожалуйста, привяжите учетную запись заново.',
  'pages.nexus.rebind': 'Привязать учетную запись GitHub заново',
  'pages.nexus.bindTitle': 'Привязка учетной записи GitHub',
  'pages.nexus.bindDesc':
    'Для генерации пользовательских клиентов необходимо привязать учетную запись GitHub. Нажмите кнопку ниже для авторизации через GitHub.',
  'pages.nexus.bindGithub': 'Авторизоваться через GitHub',
  'pages.nexus.unbind': 'Отвязать',
  'pages.nexus.repoInteractionRequired':
    'Пожалуйста, поставьте Star, Fork или Watch на репозиторий databk/rustdesk-console на GitHub. Обновление кеша может занять до 5 минут.',
  'pages.nexus.buildAlreadyRunning': 'У вас уже есть сборка в процессе',
  'pages.nexus.generateFailed': 'Не удалось отправить запрос на сборку',
  'pages.nexus.retryBuild': 'Повторить',
  'pages.nexus.retryBuildFailed': 'Не удалось повторить сборку',
  'pages.nexus.downloadFailed': 'Не удалось скачать пользовательский клиент',
  'pages.nexus.buildAgain': 'Собрать заново',
  'pages.nexus.status': 'Статус',
  'pages.nexus.statusPending': 'Ожидание сборки',
  'pages.nexus.statusBuilding': 'Сборка выполняется',
  'pages.nexus.statusCompleted': 'Сборка завершена',
  'pages.nexus.statusFailed': 'Ошибка сборки',
  'pages.nexus.statusCancelled': 'Сборка отменена',
  'pages.nexus.bindWhyLogin':
    'Аутентификация через GitHub помогает нам убедиться, что вы реальный пользователь, предотвращая автоматическое злоупотребление ресурсами сборки. Мы запрашиваем только ваши публичные данные — никакого доступа к вашим репозиториям, личным данным или другим разрешениям не требуется.',
  'pages.nexus.repoWhyInteract':
    'Я старшеклассник, разрабатывающий этот проект в свободное время. Ваши Star, Fork или Watch очень много значат для меня — это не только мотивирует меня, но и помогает с поступлением в колледж. Это единственное, что я прошу взамен. Большое спасибо за вашу поддержку!',
};
